import BackIcon from '@ancon/wildcat-ui/shared/icons/arrow-back-long.svg'
import CloseIcon from '@ancon/wildcat-ui/shared/icons/close.svg'

import HeadingText from '../../../app/components/HeadingText'
import Button from '../../../app/components/Button'
import { ModalHeaderProps } from '../../../app/components/modal/ModalHeader'

import styles from './DeliveryLocationConfigureModalHeader.module.scss'

export default function DeliveryLocationConfigureModalHeader({
  title,
  onClose,
}: ModalHeaderProps) {
  function handleGoBack() {
    onClose?.()
  }

  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <Button
          variant="secondary"
          className={styles.headerBackButton}
          onClick={handleGoBack}
          aria-label="back"
        >
          <BackIcon />
        </Button>
        <HeadingText className={styles.headerTitle} as="h2" color="heading-1">
          {title}
        </HeadingText>
      </div>
      <Button
        variant="secondary"
        className={styles.headerCloseButton}
        onClick={onClose}
        aria-label="close"
      >
        <CloseIcon />
      </Button>
    </div>
  )
}
